var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7615 9.49023H15.9867",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7615 13.4736H21.3458",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20649 1.00049C2.42984 1.00049 0.999512 2.42901 0.999512 4.20473V6.57203H7.41346",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20654 1.00049C5.98331 1.00049 7.41352 2.42901 7.41352 4.20473V6.57203V25.3264H25.6866V5.26334C25.6866 2.4092 23.5856 1.00049 20.3831 1.00049H14.6961H4.20654Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7615 17.457H21.3458",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6858,
    height: 26.3271,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeDocument);
export default __webpack_public_path__ + "static/media/icon_type_document.b607f7d11bc3768fbce6b1c19cbf16dc.svg";
export { ForwardRef as ReactComponent };